import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { ACTIONS_DOMAIN } from './constants';

const selectActionsDomain = state => state[ACTIONS_DOMAIN] || initialState;

export const selectActions = () =>
  createSelector(
    selectActionsDomain,
    d => d.actions,
  );

export const selectAction = id =>
  createSelector(
    selectActionsDomain,
    d => d.actions[id],
  );

export const selectScrollPosition = () =>
  createSelector(
  selectActionsDomain,
  d => d.scrollPosition,
);
